import api from '../../api';

const BASE = '/v1/combat-pro/sharing';

export async function ensureSharingContext(payload) {
  return (await api.post(BASE + '/context', payload)).data;
}

export async function fetchSharingPreview(campaignId, playerIds) {
  const params = { campaign_id: campaignId };
  if (playerIds && playerIds.length) params.player_ids = playerIds.join(',');
  return (await api.get(BASE + '/preview', { params })).data;
}

export async function shareInformationCard(payload) {
  return (await api.post(BASE + '/cards', payload)).data;
}

export async function correctInformationCard(cardId, payload) {
  return (await api.put(BASE + '/cards/' + encodeURIComponent(cardId), payload)).data;
}

export async function revokeInformationCard(cardId, expectedVersion) {
  return (await api.post(BASE + '/cards/' + encodeURIComponent(cardId) + '/revoke', { expected_version: expectedVersion })).data;
}

export async function fetchPlayerInformation(campaignId) {
  return (await api.get(BASE + '/player', { params: { campaign_id: campaignId } })).data;
}

export async function fetchInformationCards(mode, campaignId, query, filter, context) {
  const params = { campaign_id: campaignId, q: query || '', filter: filter || 'ALL' };
  if (context && context.session_id) params.session_id = context.session_id;
  if (context && context.encounter_id) params.encounter_id = context.encounter_id;
  return (await api.get(BASE + '/information/' + (mode === 'player' ? 'player' : 'dm'), { params: params })).data;
}

export async function updateInformationStatus(cardId, expectedVersion, informationStatus) {
  return (await api.patch(BASE + '/cards/' + encodeURIComponent(cardId) + '/live', {
    expected_version: expectedVersion, updates: { information_status: informationStatus },
  })).data;
}

export async function sendPrivateCampaignMessage(payload) {
  return (await api.post(BASE + '/messages', payload)).data;
}

export async function fetchDmPrivateMessages(campaignId) {
  return (await api.get(BASE + '/messages/dm', { params: { campaign_id: campaignId } })).data;
}

export async function fetchPrivateMessageOverview(campaignId) {
  return (await api.get(BASE + '/messages/overview', { params: { campaign_id: campaignId } })).data;
}

export async function fetchPlayerPrivateMessages(campaignId) {
  return (await api.get(BASE + '/messages/player', { params: { campaign_id: campaignId } })).data;
}

export async function markPrivateMessageRead(messageId) {
  return (await api.post(BASE + '/messages/' + encodeURIComponent(messageId) + '/read', {})).data;
}

export async function respondToPrivateMessage(messageId, payload) {
  return (await api.post(BASE + '/messages/' + encodeURIComponent(messageId) + '/respond', payload)).data;
}

export async function resolvePrivateMessage(messageId, expectedVersion) {
  return (await api.post(BASE + '/messages/' + encodeURIComponent(messageId) + '/resolve', { expected_version: expectedVersion })).data;
}

export async function archivePrivateMessage(messageId, expectedVersion) {
  return (await api.post(BASE + '/messages/' + encodeURIComponent(messageId) + '/archive', { expected_version: expectedVersion })).data;
}
